module.exports = __webpack_public_path__ + "img/erradicacion2.4d9f9ba5.png";